export enum DeceasedLocation {
  chamber = 'CAMARA',
  center = 'CENTRO'
}
